import { useStatsigClient } from '@statsig/react-bindings';

import type { SurveyListItem } from '@api/surveys/types';
import { GATES } from '@constants';
import { IconCTA, OverlayTriggerTooltip, PencilIcon } from '@utilities';
import { completedSurveyStatuses, surveyStatus } from '@api/surveys/utilities/constants';

interface EditProps {
  isHoverAction?: boolean;
  onEdit: (survey: SurveyListItem) => void;
  selectedRows: Array<SurveyListItem>;
}

const Edit = ({ isHoverAction, onEdit, selectedRows = [] }: EditProps) => {
  const { client } = useStatsigClient();
  const useCalypsoProvider = client.checkGate(GATES.USE_CALYPSO_AS_SURVEY_PROVIDER);

  if (selectedRows.length !== 1) return null;

  const survey = selectedRows[0];
  const isEditable = Boolean(
    survey &&
    (survey.status === surveyStatus.DRAFT ||
      (useCalypsoProvider && !completedSurveyStatuses.includes(survey.status)))
  );
  if (!isEditable) return null;

  return (
    <OverlayTriggerTooltip content={isHoverAction ? 'Open Editor' : ''}>
      <IconCTA
        aria-label="Open Editor"
        data-testid="edit-cta"
        icon={<PencilIcon />}
        onClick={() => onEdit(survey)}
        text={isHoverAction ? '' : 'Open Editor'}
      />
    </OverlayTriggerTooltip>
  );
};

export default Edit;
